import type { NewsArticle } from "@/types";

export const newsArticles: NewsArticle[] = [
  {
    id: "xinghe-boxoffice",
    title: "《星河彼岸》票房突破十五亿，国产硬科幻迎来新标杆",
    category: "报道",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20editorial%20news%20illustration%20of%20a%20glowing%20nebula%20and%20a%20small%20spacecraft%20silhouette%20against%20deep%20navy%20space%2C%20warm%20orange%20accent%20light%2C%20clean%20cinematic%20composition%2C%20no%20text%2C%20premium%20magazine%20feature%20image&width=1200&height=675&seq=news-cover-01&orientation=landscape",
    summary:
      "上映三周，《星河彼岸》累计票房正式突破十五亿，成为今年暑期档表现最亮眼的国产科幻作品，也再次点燃了市场对硬科幻题材的信心。",
    content: [
      "上映进入第三周，《星河彼岸》的票房曲线依然稳健。据片方公布的数据，影片累计票房已正式突破十五亿元，观影人次超过三千二百万，成为今年暑期档表现最亮眼的国产电影之一。",
      "业内人士分析，这部作品的成功并非偶然。影片在视觉呈现上达到了国产科幻的新高度，全程采用 IMAX 摄影机实拍，星云、行星与飞船的设计既有科学依据，又不失浪漫想象，给观众带来了强烈的沉浸感。",
      "更难得的是，影片并没有把重心全部放在特效上。导演陈砺行在多次采访中强调，他真正想讲的是一个关于孤独与寻找的故事。宇航员陆行舟跨越二十年的深空远征，本质上是一次对自我的追问。正是这条情感线索，让宏大叙事有了可以依靠的支点。",
      "与此同时，影片的口碑也保持稳定。在主流评分平台上，它的观众评分长期维持在八分以上，不少观众表示，影片结尾那段长达数分钟的无声长镜头，是全片最动人的时刻。",
      "有评论认为，《星河彼岸》的意义或许不止于票房。它为国产科幻提供了一种新的可能——在技术足够扎实的基础上，依然可以把情感和人文关怀放在故事的核心。",
    ],
    author: "影视观察",
    publishedAt: "2024-08-06",
  },
  {
    id: "shuqi-market",
    title: "2024 暑期档观察：观众到底在为什么样的电影买单",
    category: "报道",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20editorial%20news%20illustration%20of%20a%20crowded%20cinema%20lobby%20with%20warm%20lighting%20and%20colorful%20movie%20poster%20walls%2C%20clean%20contemporary%20composition%2C%20no%20text%2C%20premium%20magazine%20feature%20image&width=1200&height=675&seq=news-cover-02&orientation=landscape",
    summary:
      "从科幻巨制到小成本温情片，今年暑期档的票房分布出现了微妙变化。观众的选择，正在传递出清晰的信号。",
    content: [
      "每年暑期档都是观察中国电影市场最直观的窗口。今年这个窗口给出的信号，比往年更值得琢磨。",
      "一方面，头部大制作依然拥有强大的号召力，几部视觉型大片在上映首周就迅速占据排片优势。另一方面，一批中小成本的现实题材作品，凭借扎实的口碑实现了明显的长线放映，票房走出了一条罕见的逆袭曲线。",
      "这种分化背后，是观众决策逻辑的变化。随着社交媒体和评分平台的普及，观众越来越依赖真实口碑，而不是单纯的明星阵容或宣传声量。一部电影能否走远，越来越取决于它在上映后前几天的真实反馈。",
      "值得注意的是，家庭观众和小镇青年正在成为暑期档的重要增量。他们更看重观影的陪伴感和情绪价值，也更容易被贴近生活的故事打动。",
      "对创作者而言，这或许是一个提醒：在追求视听奇观的同时，别忘了观众走进影院，本质上还是为了被一个故事打动。",
    ],
    author: "票房风向标",
    publishedAt: "2024-08-14",
  },
  {
    id: "changan-season2",
    title: "《长安旧梦》官宣第二季，原班人马确认回归",
    category: "发布",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20editorial%20news%20illustration%20of%20an%20ancient%20Chinese%20palace%20courtyard%20at%20dusk%20with%20warm%20lanterns%20and%20red%20columns%2C%20ink%20blue%20and%20gold%20tones%2C%20clean%20cinematic%20composition%2C%20no%20text%2C%20premium%20magazine%20feature%20image&width=1200&height=675&seq=news-cover-03&orientation=landscape",
    summary:
      "备受好评的古装剧《长安旧梦》正式官宣续订第二季，制作方确认核心主创与主演阵容将悉数回归，剧本已进入收官阶段。",
    content: [
      "在首季收官近一年后，古装剧《长安旧梦》终于传来续订消息。制作方今日正式官宣，第二季已进入前期筹备阶段，核心主创团队与主演阵容将悉数回归。",
      "据透露，第二季的故事将紧接第一季的结尾展开。女主角在北境归来后，将面临更为复杂的朝堂格局与身世考验。编剧团队表示，本季会在保留原有权谋基调的同时，进一步加深人物之间的情感羁绊。",
      "美术团队也透露，第二季将前往更多实景取景地拍摄，力求还原更具层次感的东方美学。服饰与道具将在首季的基础上再度升级，部分重要角色的造型会有明显变化。",
      "对于观众关心的播出时间，制作方表示仍需等待正式的排播安排。不过可以确定的是，剧本已接近收官，开机时间将不晚于明年春天。",
      "首季《长安旧梦》凭借考究的服化道与张弛有度的叙事获得了极高的口碑，也让外界对这部续作抱有更高的期待。",
    ],
    author: "官方发布",
    publishedAt: "2024-07-28",
  },
  {
    id: "annual-top10",
    title: "年度十佳影视盘点：那些值得被反复回味的作品",
    category: "影评",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20editorial%20news%20illustration%20of%20an%20artistic%20collage%20of%20glowing%20film%20frames%20and%20soft%20bokeh%20lights%2C%20warm%20amber%20and%20deep%20navy%20tones%2C%20clean%20elegant%20composition%2C%20no%20text%2C%20premium%20magazine%20feature%20image&width=1200&height=675&seq=news-cover-04&orientation=landscape",
    summary:
      "从深空远征到北方乡村，从喧闹都市到安静的深夜食堂。这一年里，有哪些作品真正留在了观众心里？",
    content: [
      "好的影视作品，往往在字幕滚完之后才真正开始。它会在往后的某个瞬间，突然被你想起来。",
      "今年让人印象深刻的，既有《星河彼岸》这样以视觉奇观震撼观众的大制作，也有《最后一班地铁》这样用一镜到底讲述城市记忆的小切口作品。它们体量不同，却都找到了与观众对话的方式。",
      "在剧集领域，《长安旧梦》用一套考究的美学体系重新定义了古装剧的质感，《归途》则用近乎纪录片的克制，讲透了一个关于父子与土地的故事。",
      "海外的《东京食光》与《巴黎小酒馆》，不约而同地选择了以食物和空间为线索，去描摹普通人的孤独与温暖。这类作品没有激烈的冲突，却格外耐看。",
      "盘点每年作品时，我们总在寻找某种标准。但或许最好的标准很简单：当画面暗下去，你是否还愿意想起它。",
    ],
    author: "影评人 · 江野",
    publishedAt: "2024-08-01",
  },
  {
    id: "script-trend",
    title: "剧本创作新趋势：单元叙事为何越来越受欢迎",
    category: "影评",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20editorial%20news%20illustration%20of%20a%20writer%20desk%20with%20an%20open%20notebook%20and%20warm%20desk%20lamp%20lighting%20in%20a%20dim%20room%2C%20warm%20amber%20and%20deep%20teal%20tones%2C%20clean%20thoughtful%20composition%2C%20no%20text%2C%20premium%20magazine%20feature%20image&width=1200&height=675&seq=news-cover-05&orientation=landscape",
    summary:
      "从《东京食光》到《巴黎小酒馆》，采用单元叙事结构的剧集正在增多。这种结构为何契合当下的观看习惯？",
    content: [
      "如果你留意近几年的高分剧集，会发现一个明显的趋势：单元叙事结构正在回归。",
      "所谓单元叙事，是指剧集由相对独立的短篇故事组成，每一集或几集讲述一个完整的小故事，同时通过贯穿的人物或空间保持整体感。这种结构看似传统，却在当下重新焕发了生命力。",
      "原因之一，是观看场景的变化。观众越来越习惯在碎片化的时间里追剧，单元结构天然友好——任何一集进入都不会太困难，也不会因为错过一段而跟不上。",
      "原因之二，是单元叙事更容易承载情感浓度。以《东京食光》为例，每集围绕一位深夜访客展开，故事简短却能迅速建立共情，观众在短短几十分钟里就能获得完整的情感体验。",
      "当然，单元叙事也有它的挑战。如何在保持独立性的同时维系整体的吸引力，考验编剧的功力。《巴黎小酒馆》的做法是用一个固定的空间和一组固定的人物作为锚点，让故事在熟悉中不断产生新的可能。",
    ],
    author: "编剧笔记",
    publishedAt: "2024-07-19",
  },
  {
    id: "summer-guide",
    title: "本周末看什么？五部适合全家一起看的暖心影视推荐",
    category: "发布",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20editorial%20news%20illustration%20of%20a%20cozy%20living%20room%20with%20a%20glowing%20television%20screen%20and%20warm%20evening%20light%2C%20soft%20amber%20and%20teal%20tones%2C%20comfortable%20family%20atmosphere%2C%20clean%20composition%2C%20no%20text%2C%20premium%20feature%20image&width=1200&height=675&seq=news-cover-06&orientation=landscape",
    summary:
      "周末在家不知道看什么？我们为你挑选了五部节奏舒缓、内容温暖、适合一家人共同观看的影视作品。",
    content: [
      "周末的晚上，一家人挤在沙发上看点什么，其实是一件很有仪式感的事。",
      "《东京食光》是很好的选择。它节奏平缓，每集讲述一个温暖的小故事，看完之后会觉得心里被轻轻填满。",
      "如果更偏爱有时代感的故事，《最后一班地铁》会带来意外的感动。它讲述一位即将退休的地铁司机在最后一班列车上的奇遇，看似平淡，却在细节里藏着对一座城市深深的眷恋。",
      "想让孩子也看得开心，《夏日回声》里有明亮的夏天、海边的风，还有关于成长与勇气的细腻表达。",
      "《巴黎小酒馆》适合喜欢慢节奏的你，它像一杯温热的可可，安静而治愈。而《归途》虽然情感更沉一些，却很适合一家人一起，谈一谈那些平时说不出口的话。",
    ],
    author: "观影指南",
    publishedAt: "2024-07-30",
  },
];